import { Component, OnDestroy, OnInit, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import {
	TranslationTextSearchOption,
	TRANSLATION_TEXT_SEARCH_FIELDS
} from '../models/translation-text-search-options.model';

import { IAhsSelectModel } from '@nx-ahs/base-ahs-controls/models';
import { AhsTextComponent, AhsRadiolistComponent } from '@nx-ahs/base-ahs-controls/reactive';
import { Subscription } from 'rxjs';

import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatButtonModule } from '@angular/material/button';

@Component({
	selector: 'translation-search-filter-bar',
	templateUrl: './translation-search-filter-bar.component.html',
	styleUrls: ['./translation-search-filter-bar.component.scss'],
	standalone: true,
	imports: [
		CommonModule,
		ReactiveFormsModule,
		MatExpansionModule,
		MatButtonModule,
		FlexLayoutModule,
		AhsTextComponent,
		AhsRadiolistComponent
	]
})
export class TranslationSearchFilterBarComponent implements OnInit, AfterViewInit, OnDestroy {
	private readonly DEFAULT_SEARCH_TYPE: TranslationTextSearchOption = 'Key';
	private formControlSubscriptions: Subscription[] = [];

	public textSearchForm: FormGroup;
	public textSearchOptions: IAhsSelectModel[] = [];
	public currentSearchText: string = null;
	public currentSearchType: TranslationTextSearchOption = this.DEFAULT_SEARCH_TYPE;

	constructor(private cdr: ChangeDetectorRef) {}

	ngOnInit(): void {
		this.textSearchForm = new FormGroup({
			searchText: new FormControl(null),
			searchType: new FormControl(this.DEFAULT_SEARCH_TYPE)
		});

		this.buildTextSearchOptions();
		this.handleSearchFormChanges();
	}

	ngAfterViewInit(): void {
		// Explicitly set the default value after view initialization to ensure radio button is checked
		setTimeout(() => {
			this.textSearchForm.patchValue({
				searchType: this.DEFAULT_SEARCH_TYPE
			});
			this.cdr.detectChanges();
		});
	}

	ngOnDestroy(): void {
		this.formControlSubscriptions.forEach((sub) => {
			sub.unsubscribe();
		});
	}

	private handleSearchFormChanges() {
		this.formControlSubscriptions.push(
			this.textSearchForm.get('searchText').valueChanges.subscribe((searchText) => {
				this.currentSearchText = searchText;
			})
		);

		this.formControlSubscriptions.push(
			this.textSearchForm.get('searchType').valueChanges.subscribe((searchType) => {
				this.currentSearchType = searchType;
			})
		);
	}

	/**
	 * Builds the neccesary IAhsSelectModel from the TranslationSearchOptions
	 * @returns void
	 */
	private buildTextSearchOptions(): void {
		TRANSLATION_TEXT_SEARCH_FIELDS.forEach((searchField, index) => {
			const option = new IAhsSelectModel();
			option.id = index;
			option.isSelected = this.DEFAULT_SEARCH_TYPE == searchField ? true : false;
			option.value = searchField;
			option.viewValue = searchField;

			this.textSearchOptions.push(option);
		});
	}
}
